function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.55 46.505h19.83c1.75 0 3.17 1.429 3.17 3.191v-30.06c0-1.761-1.42-3.19-3.17-3.19H9.549v30.06z",
  stroke: "currentColor"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M58.55 18.946v30.5H6.423v-30.5m49.125-2.5v30.06H35.72c-1.751 0-3.17 1.428-3.17 3.19v-30.06c0-1.761 1.419-3.19 3.17-3.19h19.83z",
  stroke: "currentColor"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M36.907 25.838a3.308 3.308 0 004.678 0 3.308 3.308 0 004.678 0 3.308 3.308 0 004.678 0M36.907 30.713a3.308 3.308 0 004.678 0 3.308 3.308 0 004.678 0 3.308 3.308 0 004.678 0M36.907 35.588a3.308 3.308 0 004.678 0 3.308 3.308 0 004.678 0 3.308 3.308 0 004.678 0",
  stroke: "currentColor"
});

var SvgStory = function SvgStory(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 65 65",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgStory;